import { computed, Directive, input } from '@angular/core';
import { cn } from '@shared/helpers/cn';

@Directive({
  selector: '[appCard]',
  standalone: true,
  host: { '[class]': 'styles()' },
})
export class AppCardDirective {
  class = input<string>();

  type = input<'normal' | '' | 'select' | 'info' | 'form'>('normal');

  effect = input<'grow' | '' | 'select'>('');

  #base =
    'rounded-xl border relative transition transition-colors p-6 shadow-md flex flex-col';

  public styles = computed(() =>
    cn(
      this.#base,
      {
        // Type
        'cursor-pointer hover:bg-gray-200 ': this.effect() === 'select',
        'border-gray-200 bg-white': this.type() === 'normal',
        'w-full p-0 lg:min-w-[800px] lg:max-w-[70dvw] border-gray-200 bg-white':
          this.type() === 'form',
        'rounded-2xl transform border-2 p-4': this.type() === 'info',
        'transition-all hover:scale-[1.02] hover:shadow-xl':
          this.effect() === 'grow',
      },
      this.class(),
    ),
  );
}
